/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import {
  Text,
  Space,
  Conditional,
  Button,
  Cross,
} from '@cashfree-intl/coherent';
import { Form } from 'semantic-ui-react';
import CustomIcon from 'components/CustomIcons';
import Formik from 'components/Formik';
// import Label from 'components/Label';
import FormInput from 'components/FormInput';

import { ACCEPTED_SIGNATURE } from 'utils/constants';
import { titleCase, validateFileType, previewFile } from 'utils/common';

import attach from '../../../../images/icons/attach-icon.svg';
import { DOCUMENT_STATUS_APPROVED, MAX_FILE_SIZE } from '../../constants';

const getFormat = type => {
  switch (type) {
    case 'image/jpg':
    case 'image/jpeg':
      return 'jpeg';
    case 'image/png':
      return 'png';
    case 'application/pdf':
      return 'pdf';
    default:
      return 'generic';
  }
};

const UploadDocuments = ({
  closeModal,
  modeDetails,
  decrementStep,
  handleFormSubmit,
  downloadDocument,
}) => {
  const { display, documents, standardPricing, activationTime } = modeDetails;

  const fileFields = [];
  const textFields = {};

  let isAnyTextFieldApproved = false;

  const intialValues = documents.reduce((acc, obj) => {
    if (obj.type === 'file') {
      acc[obj.key] = { name: obj.value || '' };
      if (obj.docKey) acc[obj.key].docKey = obj.docKey;
      if (obj.value) acc[obj.key].fileSignature = obj.value.split('.').pop();
      fileFields.push(obj.key);
    } else if (obj.type === 'text') {
      acc[obj.key] = obj.value || '';
      textFields[obj.key] = obj.display;
      if (obj.isApproved) isAnyTextFieldApproved = true;
    }
    return acc;
  }, {});

  const showPreview = fileData => () => {
    if (fileData.file) {
      previewFile(URL.createObjectURL(fileData.file));
    } else if (fileData.docKey) {
      // fetch the signed url and then show the preview
      downloadDocument({
        data: { dockey: fileData.docKey },
        successCb: response => {
          if (response.docUrl) previewFile(response.docUrl);
        },
      });
    }
  };

  const validate = values => {
    const errors = {};
    fileFields.forEach(key => {
      if ('file' in values[key]) {
        // run the file validations
        const { file } = values[key];
        const fileSize = file.size / 1024 / 1024; // in MB
        if (fileSize > MAX_FILE_SIZE) {
          errors[key] = `Maximum file size allowed is ${MAX_FILE_SIZE} MB.`;
        } else {
          // run the file type validations
        }
      } else if (!('docKey' in values[key])) {
        errors[key] = 'Choose a file.';
      }
    });
    Object.keys(textFields).forEach(key => {
      if (!values[key]) errors[key] = `Enter ${textFields[key].toLowerCase()}.`;
    });
    return errors;
  };

  const renderUploadForm = () => (
    <Formik
      initialValues={intialValues}
      validate={validate}
      onSubmit={handleFormSubmit}
      validateOnBlur={false}
    >
      {({
        values,
        handleFieldBlur,
        handleFieldChange,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        setFieldError,
        setFieldTouched,
        ...formikProps
      }) => {
        const disableField =
          !formikProps.isValidating && formikProps.isSubmitting;

        const onFileInputChange = key => e => {
          if (e.target.files.length > 0) {
            const file = e.target.files[0];
            if (FileReader) {
              validateFileType(file, { signatures: ACCEPTED_SIGNATURE })
                .then(() => {
                  setFieldValue(key, { file });
                  if (errors[key]) setFieldError(key, '');
                })
                .catch(() => {
                  setFieldError(
                    key,
                    'File types supported are jpeg, jpg, png, pdf.',
                  );
                });
            }
          }

          if (!touched[key]) setFieldTouched(key, true);
        };

        const onCrossClick = key => () => {
          setFieldError(key, '');
          setFieldValue(key, { name: '' });
        };

        const isFileSelected = key =>
          !!(values[key] && (values[key].file || values[key].name));

        return (
          <Form autoComplete="off" onSubmit={handleSubmit}>
            {documents.map(obj => (
              <React.Fragment key={obj.key}>
                <div
                  className={`document-grid ${disableField ? 'disabled' : ''}`}
                >
                  <Conditional if={obj.display}>
                    <Text variant="b14">{obj.display}</Text>
                  </Conditional>
                  <Conditional if={obj.type === 'file'}>
                    <Conditional if={!isFileSelected(obj.key)}>
                      <Button
                        className="attach-button-label"
                        icon={attach}
                        secondary
                        size="small"
                        as="label"
                        htmlFor={obj.key}
                      >
                        <span className="small-text w-600 text-primary">
                          Choose a file
                        </span>
                      </Button>
                      <input
                        name={obj.key}
                        type="file"
                        accept=".jpeg, .jpg, .png, .pdf"
                        id={obj.key}
                        hidden
                        onChange={onFileInputChange(obj.key)}
                        disabled={disableField}
                      />
                    </Conditional>
                    <Conditional if={isFileSelected(obj.key)}>
                      <Space alignItems="center" gap={2}>
                        <CustomIcon
                          componentName="FILE_FORMAT"
                          className="file-format-icon"
                          format={
                            values[obj.key].file
                              ? getFormat(values[obj.key].file.type)
                              : values[obj.key].fileSignature
                          }
                        />
                        <Text
                          variant="b14"
                          className="file-name"
                          onClick={showPreview(values[obj.key])}
                        >
                          {values[obj.key].file
                            ? values[obj.key].file.name
                            : values[obj.key].name}
                        </Text>
                        <Conditional
                          if={obj.status !== DOCUMENT_STATUS_APPROVED}
                        >
                          <Cross size="md" onClick={onCrossClick(obj.key)} />
                        </Conditional>
                        <Conditional
                          if={obj.status === DOCUMENT_STATUS_APPROVED}
                        >
                          <div className="success-label">
                            <Text variant="b12" color="success">
                              Approved
                            </Text>
                          </div>
                        </Conditional>
                      </Space>
                    </Conditional>
                  </Conditional>
                  <Conditional if={obj.type === 'text'}>
                    {/* <Space alignItems="center" justifyContent="space-between"> */}
                    <div
                      className={obj.isApproved ? 'approved-text-field' : ''}
                    >
                      <FormInput
                        className={
                          isAnyTextFieldApproved ? 'shorter-width-input' : ''
                        }
                        fluid
                        id={obj.key}
                        name={obj.key}
                        label=""
                        value={values[obj.key]}
                        errors={errors}
                        touched={touched}
                        placeholder={`Enter ${obj.display}`}
                        onChange={handleFieldChange}
                        onBlur={handleFieldBlur}
                        disabled={disableField}
                      />
                      <Conditional if={obj.isApproved}>
                        <div className="success-label ml-2">
                          <Text variant="b12" color="success">
                            Approved
                          </Text>
                        </div>
                      </Conditional>
                      {/* </Space> */}
                    </div>
                  </Conditional>
                </div>
                <div className="document-grid" key={obj.docType}>
                  <div />
                  <Conditional if={touched[obj.key] && errors[obj.key]}>
                    <Text variant="b12" color="danger" className="mt-1">
                      {errors[obj.key]}
                    </Text>
                  </Conditional>
                </div>
              </React.Fragment>
            ))}
            <Text variant="b14" color="bodyLight">
              Activating{' '}
              <span className="text-dark w-600">{titleCase(display)}</span>{' '}
              payment mode usually takes{' '}
              <span className="text-dark w-600">
                {activationTime.toLowerCase()}
              </span>
              . A standard pricing of{' '}
              <span className="text-dark w-600">{standardPricing}</span> is
              applicable per transaction.
            </Text>
            <div className="text-right cta-wrapper">
              <Button
                type="button"
                link
                className="link"
                onClick={closeModal}
                disabled={disableField}
              >
                Cancel
              </Button>
              <Button
                primary
                type="submit"
                loading={disableField}
                disabled={disableField}
              >
                Submit
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );

  return (
    <>
      <div className="navigate-back" onClick={decrementStep}>
        <CustomIcon componentName="CHEVRONDOWN" direction="up" />
        Back
      </div>
      <Space gap={2} direction="column">
        <Space gap={3} direction="column">
          <Text variant="b14">
            To activate {titleCase(display)} for your account, we require you to
            submit the below documents.
          </Text>
          <p className="small-text text-light">
            File types supported are{' '}
            <span className="text-dark w-600">jpeg, jpg, png, pdf</span> and
            maximum file size allowed is{' '}
            <span className="text-dark w-600">2 MB.</span>
          </p>
        </Space>
        <div>{renderUploadForm()}</div>
      </Space>
    </>
  );
};

UploadDocuments.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modeDetails: PropTypes.object.isRequired,
  decrementStep: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  downloadDocument: PropTypes.func.isRequired,
};

export default UploadDocuments;
